import { useEffect, useRef, useState } from "react";

const STATS = [
  { value: 300, suffix: "+", label: "Creator campaigns" },
  { value: 5000, suffix: "+", label: "Creators in network" },
  { value: 100, suffix: "+", label: "Brands" },
  { value: 3, suffix: "X", label: "Average ROI" },
];

// Counts each stat up from zero the first time the bar scrolls into view.
const useCountUp = (ref) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setProgress(1);
      return;
    }
    let frame;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      const start = performance.now();
      const run = (now) => {
        const t = Math.min((now - start) / 1600, 1);
        setProgress(1 - Math.pow(1 - t, 3));
        if (t < 1) frame = requestAnimationFrame(run);
      };
      frame = requestAnimationFrame(run);
    }, { threshold: 0.4 });
    observer.observe(node);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [ref]);

  return progress;
};

const InfluencerStats = () => {
  const statsRef = useRef(null);
  const progress = useCountUp(statsRef);

  return (
    <section className="im-stats-section">
      <div className="container">
        <div className="im-stats" ref={statsRef} data-aos="fade-up" data-aos-once="true">
          {STATS.map(({ value, suffix, label }) => (
            <div className="im-stat" key={label}>
              <strong>
                {Math.round(value * progress)}
                <span>{suffix}</span>
              </strong>
              <small>{label}</small>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfluencerStats;
